import React, { useEffect, useState, useRef } from 'react';

import {
  Label,
  Icon,
  CustomInput,
  Switch,
  Input,
  MultiSelector,
  Button,
} from '@polichat/flamboyant';
import { toast } from 'react-toastify';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import formatPhone from '../../../../../../utils/formatPhone';
import ChannelsService from '../../../../../../services/tools/channels/channels';
import FacebookStatus from '../FacebookStatus/FacebookStatus.component';
import ProfileWabaPhoto from './ProfileWabaPhoto.component';

import DeleteChannelBsp from '../../DeleteChannelBsp';

import ProgressBar from '../../ProgressBar/ProgressBar.component';

import {
  Container,
  Section,
  SectionName,
  SectionContent,
  InputsContainer,
  InputItem,
  MultSelectorItem,
  SwitchContainer,
  ButtonContainer,
  PhoneInputContainer,
  BtnStatusChannelContainer,
} from './Profile.styles';
import { useHistory } from 'react-router-dom';
import { useFlags } from 'flagsmith/react';
import { customUseFlags } from 'src/hooks/customUseFlags';
import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

const Profile = ({ data: dataFromDad }) => {
  const {
    id,
    name,
    phone,
    status,
    display_on_webchat: WidgetDad,
  } = dataFromDad || {};

  console.log('dataFromDad', dataFromDad);

  const flag = useFlags(['enable_mmlite']);

  const enable_mmlite = customUseFlags(flag.enable_mmlite);

  // Traduções
  const profileSettings = useGlotaT('spa.certification.profileSettings');
  const channelNameLabel = useGlotaT('spa.certification.channelName');
  const phoneLabel = useGlotaT('spa.certification.phoneWithDDDAsterisk');
  const phoneNotEditable = useGlotaT('spa.certification.phoneNotEditable');
  const copyLabel = useGlotaT('spa.certification.copy');
  const phoneCopied = useGlotaT('spa.certification.phoneCopied');
  const usersCanUseChannel = useGlotaT('spa.certification.usersCanUseChannel');
  const showOnWebchatWidget = useGlotaT(
    'spa.certification.showOnWebchatWidget'
  );
  const channelStatusLabel = useGlotaT('spa.certification.channelStatus');
  const inactive = useGlotaT('spa.certification.inactive');
  const active = useGlotaT('spa.certification.active');
  const checkChannelQuality = useGlotaT(
    'spa.certification.checkChannelQuality'
  );
  const saveData = useGlotaT('spa.certification.saveData');
  const cancel = useGlotaT('spa.common.cancel');
  const channelEditedSuccess = useGlotaT(
    'spa.certification.channelEditedSuccess'
  );
  const errorSavingData = useGlotaT('spa.certification.errorSavingData');
  const errorSavingChannel = useGlotaT('spa.certification.errorSavingChannel');

  const [facebookStatusShow, facebookStatusShowSet] = useState(false);

  // Estados de requisição
  const [sendButtonDisabled, sendButtonDisabledSet] = useState(false);

  const [, setUsers] = useState([]);
  const [usersOptions, usersOptionsSet] = useState([]);
  const [usersSelected, usersSelectedSet] = useState([]);

  // Estados locais para lidar com mudanças nos valores de um input
  const [channelName, channelNameSet] = useState(name || '');
  const [channelPhone] = useState(phone || '');
  const [channelWidget, channelWidgetSet] = useState(WidgetDad === '1');
  const [channelStatus, setChannelStatus] = useState(!!status);

  const history = useHistory();

  const [wabaAccountIsEligible, setWabaAccountIsEligible] = useState(false);
  const [mmliteIsOnboarded, setMmliteIsOnboarded] = useState(false);
  const [onboardingStatus, setOnboardingStatus] = useState(null);

  useEffect(() => {
    async function fetchUsers() {
      try {
        const { data: users } = await ChannelsService.getAllUsersByCustomer(
          dataFromDad.customer_id
        );
        setUsers(users);

        // buscar todos os usuarios que tem acesso a esse canal
        const { data: usersChannel } = await ChannelsService.getAllUsersChannel(
          dataFromDad.customer_id,
          dataFromDad.id
        );

        //Usado para criar o objeto options que irá alimentar o componente MultiSelector
        if (users && users.length) {
          const _userSelected = [];

          const usersOptions = users.map((user) => {
            const add = {
              value: user.id,
              label: user.name,
            };

            if (Array.isArray(usersChannel)) {
              const _i = usersChannel.findIndex((e) => e.user_id == user.id);
              if (_i >= 0) {
                _userSelected.push(add);
              }
            }

            return add;
          });
          usersOptionsSet(usersOptions);
          usersSelectedSet(_userSelected);
        }
        return;
      } catch (error) {
        console.error(
          'Error in Profile component when getAllUsersByCustomer => ',
          error
        );
        return;
      }
    }

    fetchUsers();
  }, []);

  useEffect(() => {
    async function fetchWabaAccountIsEligible() {
      try {
        const { data } = await poliApiGatewayRequest.get(
          `/waba/mmlite/${dataFromDad.id}?customer_id=${dataFromDad.customer_id}`
        );

        setOnboardingStatus(data?.marketing_messages_onboarding_status ?? null);

        if (data?.marketing_messages_lite_api_status === 'ONBOARDED') {
          setMmliteIsOnboarded(true);
          return setWabaAccountIsEligible(false);
        }

        if (data?.marketing_messages_lite_api_status === 'ELIGIBLE') {
          return setWabaAccountIsEligible(true);
        }
        return setWabaAccountIsEligible(false);
      } catch (error) {
        setWabaAccountIsEligible(false);

        console.error(
          'Error in Profile component when getWabaAccountIsEligible => ',
          error
        );
        return;
      }
    }

    if (dataFromDad?.id) {
      fetchWabaAccountIsEligible();
    }
  }, [dataFromDad]);

  const acceptMMLiteAndContinueToApi = async () => {
    try {
      const response = await poliApiGatewayRequest.post(
        `/waba/mmlite/${dataFromDad?.config?.business_id}`,
        {
          customer_id: dataFromDad.customer_id,
        }
      );

      if (response?.data?.status === 'TERMS_OF_SERVICE_REQUEST_SENT') {
        setOnboardingStatus('TERMS_OF_SERVICE_REQUEST_SENT');
      }

      toast.success('Continue o processo de autorização dentro da Meta!');
      return;
    } catch (error) {
      console.error(
        'Error in Profile component when acceptMMLiteAndContinueToApi => ',
        error
      );
      toast.error('Erro ao autorizar MMLite API!');
      return;
    }
  };

  const handleSendForm = async () => {
    sendButtonDisabledSet(true);
    try {
      const finalSettingsObject = {
        name: channelName,
        status: channelStatus ? '1' : '0',
        display_on_webchat: channelWidget ? '1' : '0',
        users: usersSelected.map((user) => user.value),
      };

      const { data, error } = await ChannelsService.updateProfile({
        customer_id: dataFromDad.customer_id,
        channel_id: dataFromDad.id,
        formData: finalSettingsObject,
      });

      if (data) {
        toast.success(channelEditedSuccess);
        sendButtonDisabledSet(false);
      } else {
        toast.error(error?.message || errorSavingData);
        sendButtonDisabledSet(false);
      }

      return;
    } catch (error) {
      toast.error(error?.response?.data?.message || errorSavingChannel);
      console.error(
        'Error in Profile Component when handleSendForm. Error => ',
        error
      );
      sendButtonDisabledSet(false);
      return;
    }
  };

  const historyLocationState = history.location?.state;
  useEffect(() => {
    if (
      historyLocationState &&
      Object.keys(historyLocationState).includes('showChannelHealth')
    ) {
      facebookStatusShowSet(true);
    }
  }, [historyLocationState]);

  if (facebookStatusShow) {
    return (
      <FacebookStatus
        channelId={dataFromDad.id}
        customer_id={dataFromDad.customer_id}
        showProfile={() => facebookStatusShowSet(false)}
      />
    );
  }

  return (
    <>
      <ProgressBar
        currentStep={0}
        auxiliaryButton={
          enable_mmlite && mmliteIsOnboarded ? (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              background: '#d1fae5',
              border: '1px solid #6ee7b7',
              borderRadius: '6px',
              padding: '6px 12px',
              fontSize: '0.85rem',
              color: '#065f46',
              fontWeight: 600,
            }}>
              <Icon icon="poli-icon pi-check-fill" color="#059669" size="16" />
              Templates de Marketing ativos
            </div>
          ) : enable_mmlite && onboardingStatus === 'TERMS_OF_SERVICE_REQUEST_SENT' ? (
            <a
              href={`https://business.facebook.com/latest/whatsapp_manager/overview?business_id=${dataFromDad?.config?.business_id}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: '0.85rem' }}
            >
              Aceitar termos de uso no WhatsApp Manager
            </a>
          ) : enable_mmlite && wabaAccountIsEligible ? (
            <Button
              onClick={acceptMMLiteAndContinueToApi}
            >
              Autorizar templates de Marketing
            </Button>
          ) : null
        }
      />

      {enable_mmlite && onboardingStatus === 'TERMS_OF_SERVICE_REQUEST_SENT' && (
        <div style={{
          background: '#fff8e1',
          border: '1px solid #ffe082',
          borderRadius: '8px',
          padding: '16px 20px',
          margin: '0 0 16px 0',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px',
        }}>
          <Icon icon="poli-icon pi-alert-fill" color="#f59e0b" size="22" style={{ flexShrink: 0, marginTop: '2px' }} />
          <div>
            <p style={{ fontWeight: 600, marginBottom: '6px', color: '#92400e' }}>
              Aceite dos termos de uso pendente
            </p>
            <p style={{ fontSize: '0.875rem', color: '#78350f', marginBottom: '8px' }}>
              Para habilitar os templates de Marketing, o responsável pela conta precisa aceitar
              os termos de uso diretamente no <strong>WhatsApp Manager</strong> da Meta.
            </p>
            <p style={{ fontSize: '0.875rem', color: '#78350f', marginBottom: '8px' }}>
              Siga os passos abaixo:
            </p>
            <ol style={{ fontSize: '0.875rem', color: '#78350f', paddingLeft: '20px', marginBottom: '8px' }}>
              <li>Acesse o <a
                href={`https://business.facebook.com/latest/whatsapp_manager/overview?business_id=${dataFromDad?.config?.business_id}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#b45309', fontWeight: 600 }}
              >WhatsApp Manager</a> com a conta Meta do administrador</li>
              <li>Localize a notificação de termos de uso na página inicial do gerenciador</li>
              <li>Leia e aceite os termos para liberar a funcionalidade</li>
            </ol>
            <p style={{ fontSize: '0.8rem', color: '#92400e' }}>
              Após aceitar, clique em <strong>"Autorizar templates de Marketing"</strong> nesta tela para concluir a ativação.
            </p>
          </div>
        </div>
      )}

      <Container>
        <Section>
          <SectionName>{profileSettings}</SectionName>

          <SectionContent>
            <InputsContainer>
              <InputItem>
                <Label id="channel-name-label" for="channel-name">
                  <Icon
                    icon="poli-icon pi-channels-fill"
                    color="var(--green-polichat)"
                    size="20"
                  />
                  {channelNameLabel}
                </Label>
                <Input
                  type="text"
                  name="channel-name"
                  id="channel-name"
                  value={channelName}
                  onChange={(e) => {
                    channelNameSet(e.target.value);
                  }}
                  maxLength={50}
                />
                <br />
                <Label id="phone-number-label" for="phone-number">
                  <Icon
                    icon="poli-icon pi-smartphone-fill"
                    color="var(--green-polichat)"
                    size="20"
                  />
                  {phoneLabel}
                </Label>
                <PhoneInputContainer>
                  <Input
                    type="text"
                    value={formatPhone(channelPhone)}
                    disabled="true"
                    style={{ borderColor: 'var(--secondary-font-color)' }}
                  />
                  <Button
                    onClick={() => {
                      navigator.clipboard.writeText(phone);
                      toast.success(phoneCopied);
                    }}
                  >
                    <Icon icon="poli-icon pi-copy-fill" size="30" />
                    {copyLabel}
                  </Button>
                </PhoneInputContainer>
                <div style={{ color: 'var(--danger)', fontSize: '0.7rem' }}>
                  {phoneNotEditable}
                </div>
                <br />
                <MultSelectorItem>
                  <Label
                    id="select-users-channel-label"
                    for="select-users-channel"
                  >
                    <Icon
                      icon="poli-icon pi-perfil-fill"
                      color={'var(--green-polichat)'}
                      size="20"
                    />
                    {usersCanUseChannel}
                  </Label>
                  <MultiSelector
                    name="select-users-channel"
                    id="select-users-channel"
                    options={usersOptions}
                    values={usersSelected}
                    selectedValues={(data) => usersSelectedSet(data)}
                  />
                </MultSelectorItem>
              </InputItem>

              <InputItem>
                <ProfileWabaPhoto channelData={dataFromDad} />
              </InputItem>
            </InputsContainer>
          </SectionContent>

          <Section className="mt-3">
            <SectionContent>
              <InputsContainer>
                <InputItem className="py-3">
                  <CustomInput
                    type="checkbox"
                    id="show-widget-at-webchat"
                    label={showOnWebchatWidget}
                    checked={channelWidget}
                    onChange={(e) => {
                      channelWidgetSet(e.target.checked);
                    }}
                  />
                </InputItem>
                <InputItem>
                  <Label id="channel-status" for="channel-status">
                    <Icon
                      icon="poli-icon pi-channels-fill"
                      color="var(--green-polichat)"
                      size="20"
                    />
                    {channelStatusLabel}
                  </Label>
                  <SwitchContainer>
                    <p>{inactive}</p>
                    <Switch
                      color="primary"
                      isChecked={channelStatus}
                      onClick={(e) => {
                        setChannelStatus(e.target.checked);
                      }}
                    />
                    <p>
                      {active} {!!channelStatus}
                    </p>
                  </SwitchContainer>
                </InputItem>
              </InputsContainer>
            </SectionContent>

            <ButtonContainer style={{ justifyContent: 'space-between' }}>
              <Button
                size="lg"
                color="outline-primary"
                onClick={() => {
                  facebookStatusShowSet(true);
                }}
              >
                {checkChannelQuality}
              </Button>
              <ButtonContainer style={{ marginTop: '0px' }}>
                <Button
                  gradient="primary"
                  size="lg"
                  onClick={handleSendForm}
                  disabled={sendButtonDisabled}
                >
                  {saveData}
                </Button>
                <Button
                  color="danger"
                  size="lg"
                  style={{ width: '9rem' }}
                  onClick={() => {
                    history.push('/tools/channels');
                  }}
                >
                  {cancel}
                </Button>
              </ButtonContainer>
              <DeleteChannelBsp channel={dataFromDad} size={'lg'} />
            </ButtonContainer>
          </Section>
        </Section>
      </Container>

    </>
  );
};

export default Profile;
